import { useEffect, useState } from 'react';
import { readAddressList } from '@/api/asset/addresses/read';
import { ResAddressListType } from '@/types/addresses/read-types';
import { Tables } from '../pools/table/Tables';
import { AddressesTableColumns } from '../pools/table/ColumnsData';

export default function AddressesList() {
  const [list, setList] = useState<ResAddressListType[]>([]);

  useEffect(() => {
    (async () => {
      const payload = {
        code: sessionStorage.getItem('code')!,
      };
      const re = await readAddressList(payload);
      if (re.status !== 200) {
        return;
      }
      const list = re.data.map((item: ResAddressListType) => ({
        ...item,
        index: item.address,
        isActiveType: item.isActive === 1 ? '활성' : '비활성',
      }));
      setList(list);
    })();

    return () => {};
  }, []);

  return <>{list && <Tables list={list} columns={AddressesTableColumns} />}</>;
}
